import { render } from "./RecentBuyPriceModal.vue?vue&type=template&id=ff9c47f8&scoped=true"
import script from "./RecentBuyPriceModal.vue?vue&type=script&lang=js"
export * from "./RecentBuyPriceModal.vue?vue&type=script&lang=js"

import "./RecentBuyPriceModal.vue?vue&type=style&index=0&id=ff9c47f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9c47f8"]])

export default __exports__